import React from 'react'
import { connect } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import DiscsList from './DiscsList'

function BagDetails({ bags, discs, discsToBags }) {
  const { bagUuid } = useParams()
  const bag = bags.find((b) => b.uuid === bagUuid)

  if (!bag) {
    return (
      <div className="bag-details">
        <Link to="/discs/bags" className="discs-back">
          ← Back to bags
        </Link>
        <p className="discs-empty">Bag not found.</p>
      </div>
    )
  }

  const bagDiscUuids = discsToBags
    .filter((link) => link.bu === bag.uuid)
    .map((link) => link.du)
  const bagDiscs = bagDiscUuids
    .map((uuid) => discs.find((d) => d.uuid === uuid))
    .filter(Boolean)

  return (
    <div className="bag-details">
      <Link to="/discs/bags" className="discs-back">
        ← Back to bags
      </Link>
      <h2>{bag.nm}</h2>
      <p className="bag-details--meta">
        {bag.b && <span>{bag.b}</span>}
        <span>
          {bagDiscs.length}
          {bag.c ? ` / ${bag.c}` : ''} discs
        </span>
        {bag.w ? <span>{bag.w} g</span> : null}
      </p>
      <DiscsList discs={bagDiscs} />
    </div>
  )
}

const mapStateToProps = (state) => ({
  bags: state.discs.bags,
  discs: state.discs.discs,
  discsToBags: state.discs.discsToBags,
})

export default connect(mapStateToProps)(BagDetails)
